import { I18NService } from '@ebw-monorepo/i18n-translate';
import { ExternalActionService, LayerStylesService, MapService } from '@ebw-monorepo/map';
import { EbwModalService } from '@ebw-monorepo/modal';
import { SplitViewService } from '@ebw-monorepo/utils';

import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from '@ebw-monorepo/login';
import { IMapTable } from '../../../interfaces/mapTable.interface';
import { MapRequestService } from '../../../services/map-request.service';
import { IHttpMapGet } from './../../../interfaces/httpReq.interface';
import { IQueryList } from './../../../interfaces/query.interface';
import { QueryService } from './../../../services/query.service';
import { API_URLS, ApiUrlService } from '../../../../../../utils/src/lib/services/api-url.service';

@Component({
  selector: 'ebw-monorepo-query',
  templateUrl: './query.component.html',
  styleUrls: ['./query.component.scss']
})
export class QueryComponent implements OnInit, OnDestroy {
  querys: IQueryList[] = [];
  limit: number = 10;
  rows: number = 0;

  datasets: any[];
  pageIndex: number = 0;

  inputRicerca = new FormControl();
  public ricerca: string = '';
  searchTimeout: any;

  currentUserId: string;

  constructor(
    private httpSrv: MapRequestService,
    private route: ActivatedRoute,
    private router: Router,
    private ebwModalSrv: EbwModalService,
    private i18nSrv: I18NService,
    private querySrv: QueryService,
    private externalSrv: ExternalActionService,
    private layerStyleService: LayerStylesService,
    private mappaService: MapService,
    private _homeSplitView: SplitViewService,
    private changeDetectorRef: ChangeDetectorRef,
    private _apiUrlService: ApiUrlService
  ) {}

  ngOnInit(): void {
    this.externalSrv.nextViewerManager(false);
    this.getQueryList();

    this.currentUserId = sessionStorage.getItem(LoginService.USER_ID_KEY);

    this.datasets = history.state.config;
  }

  ngOnDestroy(): void {
    this.mappaService.clearAllFeaturesFromTemporaryLayer(true);
  }

  managerQueryGo(query?: any) {
    let params = {
      title: 'map.sidebar.query.new_query',
      id: null,
      datasets: this.datasets
    };

    if (query) {
      params.title = query.query_name;
      params.id = query.id;
    }
    this.externalSrv.nextViewerManager(true);
    this.router.navigate(['/home', { outlets: { sidebarAction: ['query-form'] } }], {
      relativeTo: this.route,
      state: params
    });
  }

  getQueryList(offset: number = 0) {
    this.mappaService.clearAllFeaturesFromTemporaryLayer(true);

    let req: IHttpMapGet = {
      url: this._apiUrlService.createUrl(API_URLS.MAP.QUERY.LIST) + '?&offset=' + offset + '&limit=' + this.limit,
      user_id: sessionStorage.getItem(LoginService.USER_ID_KEY)
    };
    if (this.ricerca != '') {
      req.url += '&query_name=' + this.ricerca;
    }
    this.httpSrv.getMapRequest(req).subscribe({
      next: (resp: any) => {
        this.querys = resp.records;
        this.rows = resp.numRows;
      },
      error: (error) => {
        this.ebwModalSrv.openSuccessModal({
          title: this.i18nSrv.getInstantValue('common.error'),
          content: this.i18nSrv.getInstantValue('common.data_retrieving_error')
        });
      }
    });
  }

  filterQuery(value: string): void {
    const filterValue = value.toLowerCase();
    clearTimeout(this.searchTimeout);

    //Il delay per la ricerca
    this.searchTimeout = setTimeout(() => {
      this.pageIndex = 0;
      this.getQueryList();
    }, 500);
  }

  changePage(event) {
    let offset = this.limit * event.pageIndex;
    this.pageIndex = event.pageIndex;
    this.getQueryList(offset);
  }

  queryExec(query) {
    // this.mappaService.clearFeatureFromTemporaryLayerById('update_query_geom', true);
    // this.mappaService.clearAllFeaturesFromTemporaryLayer();
    this.mappaService.clearAllFeaturesFromTemporaryLayer(true);

    //TODO: copia da query-form, implementare meglio
    // cerco nelle condizioni se c'è una condizione spaziale
    const geoCond = query.asset_query_cond.find(
      (_) => _.comparison == 'within' && _.field_type == 'geometry' && _['geom']
    );

    let geometry: any;

    if (geoCond) {
      const currentLayoutConf = this._homeSplitView.viewLayountConfig$.value;
      if (currentLayoutConf && currentLayoutConf.isEnable) {
        currentLayoutConf.halfScreen = true;
        currentLayoutConf.collapsed = false;
        this._homeSplitView.layoutConfChange(currentLayoutConf);
      }
      this.changeDetectorRef.detectChanges();

      geometry = geoCond['geom'];
      const geoFeatureStyle = this.layerStyleService.buildFeatureStyleFromId('AcdaFill');

      this.mappaService.addFeatureToTemporaryLayer(geometry, geoFeatureStyle, true, false, 'update_query_geom');
    }

    const config: IMapTable = {
      id: query.id,
      url: this._apiUrlService.createUrl(API_URLS.MAP.QUERY.EXEC),
      title: 'map.map_table.results_query',
      pagination: true,
      marker: 'place',
      infoColumn: true,
      pinnableRow: true,
      // count: true,
      queryGeometry: geoCond ? geometry : null,
      queryName: query.query_name
      // groupButtons: [{name: "query", label: "Query"}]
    };

    this.querySrv.queryExec(config);
  }

  deleteQuery(id: number, name: string) {
    let req: IHttpMapGet = {
      url: this._apiUrlService.createUrl(API_URLS.MAP.QUERY.UPDATE)
    };

    let body = {
      id: id,
      user_id: sessionStorage.getItem(LoginService.USER_ID_KEY),
      deleted: 1
    };

    this.querySrv.deleteQuery(req, body, name, this.getQueryList.bind(this));
    this.pageIndex = 0;
  }

  getQueryDescription(query: any, limit: number = 30): string {
    let text = `${query.dataset} - ${query.table_label}`;

    return text.length > limit ? text.slice(0, limit) + '...' : text;
  }

  getTooltipDescription(query: any, limit: number = 30): string {
    let text = `${query.dataset} - ${query.table_label}`;

    return text.length > limit ? text : '';
  }
}
